<template>
  <div class="control">
    <el-container>
      <el-menu :default-active="defaultActive" :router="true" class="el-menu-vertical-demo" background-color="#2d2d2d"
        text-color="#ffffff" active-text-color="#EC8E00" :collapse="isCollapse">
        <el-menu-item @click="isCollapse = !isCollapse">
          <i class="el-icon-s-help"></i>
          <span slot="title">{{
            $store.state.shortName == null
              ? "上海益埃毕"
              : $store.state.shortName
          }}</span>
        </el-menu-item>
        <el-menu-item class="textEllipsis" :index="'/' + item.path" v-for="(item, index) in menuData" :key="index"
          :route="item.path">
          <i :class="item.icon" v-if="!item.icon.includes('ktr-')"></i>
          <i class="icon iconfont" :class="item.icon" v-else></i>
          <span slot="title" :style="{ letterSpacing: isEn ? 'normal' : '' }" :title="item.authName">{{ item.authName
            }}</span>
        </el-menu-item>
      </el-menu>
      <el-main>
        <router-view v-if="viewShow" ref="view"></router-view>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import { GetProjectInfo, GetRoleList, GetFunctionTemplate } from "@/setAxios";
export default {
  name: "projectControl",
  data() {
    return {
      viewShow: true,
      defaultActive: null,
      isCollapse: true,
      menuData: [],
      ActiveMenuId: "",
      isEn: this.$i18n.locale == 'en'
    };
  },
  methods: {
    defImg(event) {
      let img = event.srcElement;
      img.src = "./img/6.0/PC/风险管理.png";
      img.onerror = null; //防止闪图
    },
    getTreeDate(data, idName, pidName) {
      let result = [];
      if (!Array.isArray(data)) {
        return result;
      }
      data.forEach((item) => {
        item.id = `Tree${item[idName]}`;
        item.authName = item.fctm02;
        delete item.children;
      });
      let map = {};
      data.forEach((item) => {
        item["path"] = "MenuTemplate";
        map[item[idName]] = item;
      });

      data.forEach((item) => {
        let parent = map[item[pidName]];
        if (parent) {
          parent.parentName
            ? (item.parentName = "-" + parent.parentName + item.authName)
            : (item.parentName = parent.authName + "-" + item.authName);
          (parent.children || (parent.children = [])).push(item);
        } else {
          (item["icon"] = "el-icon-star-on"), result.push(item);
        }
      });
      return result;
    },
    MenuInquire(i) {
      if (i == "") {
        this.menuData = this.$store.state.MenuTemplateList;
      } else {
        this.menuData = this.find(this.$store.state.MenuTemplateList, i);
      }
    },
    find(list, name) {
      let _this = this;
      let result = list.reduce((p, el) => {
        if (el.authName.includes(name)) {
          p.push(el);
        } else if (el.children && el.children.length) {
          p = p.concat(_this.find(el.children, name));
        }
        return p;
      }, []);
      return result;
    },
    // 点击项目进行跳转
    pushProject(item) {
      this.$store.state.xidName = item.proj07;
      localStorage.setItem("xid", item.proj01);
      this.$store.state.xid = item.proj01;
      localStorage.setItem("XmName", item.proj07);
      localStorage.setItem("XmBh", item.proj02);
      let params = {
        qid: localStorage.pid,
        xid: localStorage.xid,
        uid: localStorage.id,
      };
      GetRoleList(params).then((res) => {
        if (res.Data.length == 0) {
          this.$message({
            type: "warning",
            message: this.$t('common.当前用户在此项目中未设置角色请联系管理员'),
          });
          return false;
        }
        this.$store.state.isClickProject = true;
        this.$store.state.jobs = res.Data;
        this.$store.state.roleName = res.Data[0].roleName;
        if (res.Data[0].isPM) {
          this.$store.state.isProject = true;
        } else {
          this.$store.state.isProject = false;
        }
        this.$store.state.permissions =
          res.Data[0].roleRight == null
            ? null
            : res.Data[0].roleRight.split(",");
      });
    },
    out() {
      outLogin().then((res) => {
        localStorage.removeItem("token");
        this.$message({
          type: "success",
          message: this.$t('common.处理成功'),
        });
        this.$router.push({
          path: "/login",
        });
      });
    },
    // 执行刷新
    refreshData() {
      this.viewShow = false;
      this.$nextTick(() => {
        this.viewShow = true;
      });
    },

    dealNodes() {
      let _this = this;
      this.menuData = [
        {
          id: 101,
          authName: this.$t('xmzycbl.projectHome'),
          icon: "el-icon-s-home",
          path: "userProjectIndex"
        },
        {
          id: 102, authName: this.$t('xmzycbl.ApplicationNavigation'), icon: "el-icon-menu", path: "userViewModel",
        },
        {
          id: 201,
          authName: this.$t('xmzycbl.DirectoryOfCommunications'), icon: "el-icon-phone",
          path: "communication",
        },
        {
          id: 401,
          authName: this.$t('xmzycbl.ListOfannotations'), icon: "ktr-pizhu",
          path: "annotationList",
        },
        { id: 801, authName: this.$t('xmzycbl.ProjectData'), icon: "el-icon-s-order", path: "dataList" },
        { id: 803, authName: this.$t('xmzycbl.PersonalData'), icon: "el-icon-user-solid", path: "myData" },
        {
          id: 60404,
          authName: this.$t('xmzycbl.ProgressDisplay'),
          path: "progressShow", icon: "el-icon-s-claim",
          isShow: (function () {
            return _this.$store.state.isProject ||
              (_this.$store.state.permissions != null &&
                _this.$store.state.permissions.includes("1033"))
              ? true
              : false;
          })(),
        },

        { id: 202, authName: this.$t('xmzycbl.EngineeringDynamic'), icon: "el-icon-s-marketing", path: "weibo" },
        {
          id: 203,
          authName: this.$t('xmzycbl.DiscussTheTopic'),
          icon: "el-icon-s-promotion",
          path: "discussTheTopic",
          isShow: (function () {
            return _this.$store.state.isProject ||
              (_this.$store.state.permissions != null &&
                _this.$store.state.permissions.includes("1013"))
              ? true
              : false;
          })(),
        },
        {
          id: 301,
          authName: this.$t('xmzycbl.WorkOrderTask'),
          path: "workOrder",
          icon: "el-icon-s-cooperation",
          isShow: (function () {
            return _this.$store.state.isProject ||
              (_this.$store.state.permissions != null &&
                _this.$store.state.permissions.includes("1021"))
              ? true
              : false;
          })(),
        },
        { id: 1001, authName: this.$t('xmzycbl.RealScenicSpot'), path: "liveBarCode", icon: "ktr-shijing", },
      ];
      // this.menuData = [
      //   {
      //     id: "userProjectIndex",
      //     authName: "项目概览",
      //     icon: "el-icon-star-on",
      //     children: [
      //       {
      //         id: 101,
      //         authName: "项目主页",
      //         path: "userProjectIndex",
      //         children: [],
      //       },
      //       {
      //         id: "useManager",
      //         authName: "应用导航",
      //         path: "userViewModel",
      //         children: [],
      //       },
      //       {
      //         id: "teamManager",
      //         authName: "团队成员",
      //         path: "teamUser",
      //         icon: "el-icon-user-solid",
      //         children: [
      //           {
      //             id: 201,
      //             authName: "通讯目录",
      //             path: "communication",
      //           },
      //           { id: 202, authName: "工程动态", path: "weibo" },
      //           {
      //             id: 203,
      //             authName: "话题讨论",
      //             path: "discussTheTopic",
      //             isShow: (function () {
      //               return _this.$store.state.isProject ||
      //                 (_this.$store.state.permissions != null &&
      //                   _this.$store.state.permissions.includes("1013"))
      //                 ? true
      //                 : false;
      //             })(),
      //           },
      //         ],
      //       },
      //       {
      //         id: "commentManager",
      //         authName: "协作沟通",
      //         path: "collaboration",
      //         icon: "el-icon-s-flag",
      //         isShow: (function () {
      //           return _this.$store.state.isProject ||
      //             (_this.$store.state.permissions != null &&
      //               _this.$store.state.permissions.includes("102"))
      //             ? true
      //             : false;
      //         })(),
      //         children: [
      //           {
      //             id: 301,
      //             authName: "工单任务",
      //             path: "workOrder",
      //             isShow: (function () {
      //               return _this.$store.state.isProject ||
      //                 (_this.$store.state.permissions != null &&
      //                   _this.$store.state.permissions.includes("1021"))
      //                 ? true
      //                 : false;
      //             })(),
      //           },
      //         ],
      //       },
      //       {
      //         id: "barManager",
      //         authName: "条码管理",
      //         path: "barCode",
      //         icon: "el-icon-s-help",
      //         children: [
      //           { id: "901", authName: "条码点位", path: "location" },
      //           { id: "902", authName: "条码列表", path: "barCodeList" },
      //         ],
      //       },
      //       {
      //         id: "scenceManager",
      //         authName: "实景管理",
      //         path: "live",
      //         icon: "el-icon-s-grid",
      //         children: [
      //           { id: 1001, authName: "实景点位", path: "liveBarCode" },
      //           { id: 1002, authName: "实景列表", path: "liveList" },
      //         ],
      //       },
      //       {
      //         id: "DataBoard",
      //         authName: "数据看板",
      //         path: "DataBoard",
      //         icon: "el-icon-s-grid",
      //         children: [],
      //       },
      //     ],
      //   },
      //   {
      //     id: "zlManager",
      //     authName: "资料管理",
      //     path: "dataManagement",
      //     icon: "el-icon-star-on",
      //     children: [
      //       { id: 801, authName: "项目资料", path: "dataList" },
      //       // { id: 802, authName: "图纸资料", path: "DrawingsList" },
      //       { id: 803, authName: "个人资料", path: "myData" },
      //       { id: 804, authName: "审核资料", path: "auditData" },
      //     ],
      //   },
      //   {
      //     id: "jdManager",
      //     authName: "进度管理",
      //     icon: "el-icon-star-on",
      //     path: "jdManager",
      //     children: [
      //       {
      //         id: 60401,
      //         authName: "进度计划",
      //         path: "progressPlan",
      //         isShow: (function () {
      //           return _this.$store.state.isProject ||
      //             (_this.$store.state.permissions != null &&
      //               _this.$store.state.permissions.includes("1032"))
      //             ? true
      //             : false;
      //         })(),
      //       },
      //       {
      //         id: 60402,
      //         authName: "三维模拟",
      //         path: "simulation",
      //         isShow: (function () {
      //           return _this.$store.state.isProject ||
      //             (_this.$store.state.permissions != null &&
      //               _this.$store.state.permissions.includes("1031"))
      //             ? true
      //             : false;
      //         })(),
      //       },
      //       { id: 60403, authName: "形象进度", path: "trueProgress" },
      //       {
      //         id: 60404,
      //         authName: "进度展示",
      //         path: "progressShow",
      //         isShow: (function () {
      //           return _this.$store.state.isProject ||
      //             (_this.$store.state.permissions != null &&
      //               _this.$store.state.permissions.includes("1033"))
      //             ? true
      //             : false;
      //         })(),
      //       },
      //     ],
      //   },
      // ];
      this.menuData = this.dealNodesIsShow(
        JSON.parse(JSON.stringify(this.menuData))
      );
    },
    dealNodesIsShow(menuData) {
      menuData.forEach((v, i) => {
        if (v.isShow != undefined && v.isShow == false) menuData.splice(i, 1);
        else if (v.children) this.dealNodesIsShow(v.children);
      });
      return menuData;
    },
    refresh() {
      // let that = this;
      // // 这里根据权限赋值
      // GetFunctionTemplate({
      //   params: { xid: localStorage.xid },
      // }).then((res) => {
      //   this.dealNodes();
      //   var dataMenu = that.getTreeDate(
      //     res.Data.projectfunctiontemplates,
      //     "fctm01",
      //     "fctm03"
      //   );

      //   that.menuData = that.menuData.concat(dataMenu);
      //   this.$store.commit("SetMenuTemplate", that.menuData);
      // });
       this.dealNodes();
    }
  },
  // 利用计算属性
  computed: {
    xidNameupdata() {
      return this.$store.state.xidName;
    },
    roleNameUpdata() {
      return this.$store.state.roleName;
    },
    routerPath() {
      return this.$route.name;
    },
  },
  //监听执行
  watch: {
    $route: {
      handler: function (newRoute, oldRoute) {
        this.defaultActive = newRoute.path
      },
      // 深度观察监听
      deep: true
    },
    xidNameupdata() {
      window.location.href = "/#/userProjectIndex";
    },
    roleNameUpdata() {
      this.refresh();
    },
  },
  created() {
    this.defaultActive = this.$route.path
    if (!this.$store.state.isClickProject) {
      this.$store.state.btnStyle[0] = "btns";
      this.$store.state.btnStyle[1] = "btnss";
      this.$store.state.btnStyle[2] = "btns";
      this.$store.state.btnStyle[3] = "btns";
      if (localStorage.xid) {
        let params = {
          id: localStorage.xid,
        };
        GetProjectInfo({ params }).then((res) => {
          let item = res.Data;
          this.pushProject(item);
        });
      }
    }
    this.refresh();
  },
  mounted() { },
  updated() {
  },
};
</script>

<style lang="less" scoped>
.flexLR {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.control {
  width: 100%;
  height: 100%;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
}

.el-container {
  display: -webkit-box;
  width: 100%;
  height: 100%;
}


/deep/.el-submenu__title i {
  color: #fff;
}

.el-menu-vertical-demo {
  height: 100%;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  overflow-x: hidden;
  // width: 22%;
  height: 100%;
}

/* 新增 */
.bg-cor {
  background-color: rgba(0, 0, 0, 0);
  overflow: hidden;
}

.height100 {
  height: 100%;
}

.mar-r36p {
  margin-right: 36px;
}

.font-sz18 {
  font-size: 18px;
  font-weight: 600;
}

.el-menu-item i {
  color: #fff;
}
</style>
